{
	"backToManageDeclarations": "Tilbake til Administrer erklæringer",
	"kpi": {
		"quantity": "Mengde",
		"carbonSavings": "Karbonreduksjoner"
	},
	"downloadAllDeclarations": "Last ned alle erklæringer",
	"errors": {
		"notFound": "Finner ikke prosjektet"
	}
}
